import { render, staticRenderFns } from "./PdpPillowHeightGuide.vue?vue&type=template&id=9fe41540&scoped=true&"
import script from "./PdpPillowHeightGuide.vue?vue&type=script&lang=js&"
export * from "./PdpPillowHeightGuide.vue?vue&type=script&lang=js&"
import style0 from "./PdpPillowHeightGuide.vue?vue&type=style&index=0&id=9fe41540&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe41540",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconInfo: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconInfo.vue').default,SvgIconCloseV2: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconCloseV2.vue').default})
